import { createFileRoute, redirect } from "@tanstack/react-router";
import { EntriesSectorDashboard } from "../../components/dashboard/entries-sector";
import { type EntriesSearch, entriesSearchSchema } from "../../components/entries/entries-page";
import { hasSectorDashboards } from "../../lib/dashboard/sectors";

/** Sector 1 · Dashboard (Early Planning Phase): the sport entries. Admins: the Entries analytics; a NOC: its own two phases. */
export const Route = createFileRoute("/_app/dashboard/entries")({
	beforeLoad: ({ context }) => {
		if (!hasSectorDashboards(context.session)) throw redirect({ to: "/", replace: true });
	},
	validateSearch: entriesSearchSchema,
	staticData: { contentWidth: "full" },
	component: Page,
});

function Page() {
	const { session } = Route.useRouteContext();
	const search = Route.useSearch() as EntriesSearch;
	const navigate = Route.useNavigate();
	return <EntriesSectorDashboard session={session} search={search} patch={(next) => void navigate({ search: (prev) => ({ ...prev, ...next }), replace: true })} />;
}
